import { NgModule } from '@angular/core';
import { PaginatorComponent } from './paginator/paginator.component';

@NgModule({
  imports: [],
  exports: [PaginatorComponent],
  declarations: [PaginatorComponent],
  providers: [],
})
export class PaginatorModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/paginator/paginator.module.ts